import React from "react";

import {
    BulletPointHeaderText,
    BulletPoints,
    PrimaryPriceText,
    SecondaryPriceText,
    PriceLayout,
    HeaderAndPriceLayout,
    CardLayout,
    HeaderLayout,
    BulletPoint
} from "core/SubscriptionUpsellCard";

const UpgradableSubscriberUpsell = () => (
    <CardLayout>
        <HeaderAndPriceLayout>
            <HeaderLayout>
                <BulletPointHeaderText>
                    Free with Pro Upgrade
                </BulletPointHeaderText>
            </HeaderLayout>
            <PriceLayout>
                <PrimaryPriceText>$9.99/mo</PrimaryPriceText>
                <SecondaryPriceText>paid yearly</SecondaryPriceText>
            </PriceLayout>
        </HeaderAndPriceLayout>
        <BulletPoints>
            <BulletPoint>All Icon Pro benefits PLUS</BulletPoint>
            <BulletPoint>Unlimited icon set downloads</BulletPoint>
            <BulletPoint>Unlimited Standard photos</BulletPoint>
            <BulletPoint>Current payment applies to upgrade</BulletPoint>
        </BulletPoints>
    </CardLayout>
);

export default UpgradableSubscriberUpsell;
